export default "__VITE_ASSET__mw6ZXTOT__"